module.exports = __webpack_public_path__ + "img/banner(1).51af4ac3.png";